export default "__VITE_ASSET__CCnh9m5x__"